/**
 * Content - Text Block JavaScript
 */

(function() {
    'use strict';
    
    // Initialize block functionality
    function initContentText() {
        const blocks = document.querySelectorAll('.content-text');
        
        blocks.forEach(block => {
            // Add your block functionality here
            console.log('[BLOCK] content-text block initialized');
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initContentText);
    } else {
        initContentText();
    }
})();